import { Slider as AntSlider } from 'antd';
import React from 'react';

import Slider from './Slider.style';

type DayRangeSelectorProps = Pick<React.ComponentProps<typeof AntSlider>, 'onChange' | 'disabled'> & {
    value?: [number, number];
    defaultValue?: [number, number];
    onChange?: (value: [number, number]) => void;
};

const generateMarks = (marks: number[]) => marks.reduce<{ [key: string]: number }>((acc, mark) => ({ ...acc, [mark]: mark }), {});

const MARKS = [-31, -25, -20, -15, -10, -5, 0, 5, 10, 15];
const DAY_RANGE_MARKS = generateMarks(MARKS);

const DayRangeSelector: React.FC<DayRangeSelectorProps> = ({ onChange, value, disabled, defaultValue = [0, 5] }) => (
    <div style={{ width: '100%' }}>
        <Slider
            range
            style={{ width: '100%' }}
            value={value}
            defaultValue={defaultValue}
            marks={DAY_RANGE_MARKS}
            min={MARKS[0]}
            max={MARKS[MARKS.length - 1]}
            included={true}
            disabled={disabled}
            onChange={onChange}
        />
    </div>
);

export default DayRangeSelector;
export { DayRangeSelectorProps };
